import { render, staticRenderFns } from "./TagCategoryTable.vue?vue&type=template&id=36cae052"
import script from "./TagCategoryTable.vue?vue&type=script&lang=js"
export * from "./TagCategoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports